import store from '@@/assets/js/store';
import Vue from 'vue';
import VueRouter from 'vue-router';
import { sync } from 'vuex-router-sync';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { path } from '@antv/x6/lib/registry/marker/path';

Vue.use(VueRouter);
// const originalPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push(location) {
// 	return originalPush.call(this, location).catch(err => err)
// }

const router_c = new VueRouter({
  base: '/',
  //mode: process.env.NODE_ENV == "development" ? 'hash' : 'history',
  mode: 'hash',
  routes: []
});

router_c.beforeEach((to, from, next) => {
  if (to.path.contains('http://')) {
    window.open('http' + to.path.split('http')[1] + '?token=' + localStorage.getItem('token') + '&ssoToken=' + localStorage.getItem('ssoToken'), '_blank');
    return;
  }
  if (to.path.contains('https://')) {
    console.log('https' + to.fullPath.split('https')[1] + '?token=' + localStorage.getItem('token') + '&ssoToken=' + localStorage.getItem('ssoToken'), '_blank');
    window.open('https' + to.fullPath.split('https')[1] + '?token=' + localStorage.getItem('token') + '&ssoToken=' + localStorage.getItem('ssoToken'), '_blank');
    return;
  }

  // NProgress.start()会造成计算高度的时候滚动条闪烁
  if (to.path == '/utils/preview') {
    next();
    return;
  }
  if (to.path == '/login') {
    next();
    return;
  }
  if (!Vue.prototype.utils.isUserLogin()) {
    Vue.prototype.utils.event_hub.$emit('NEED_LOGIN', null);
    next();
    return;
  }
  Vue.prototype.utils.event_hub.$emit('TOGGLE_TABBAR', false);

  // let a = setInterval(() => {
  // 	if (store.state.is_base_data_ready) {
  // 		clearInterval(a)
  // 		next()
  // 	}
  // })
  if (to.meta.name) {
    document.title = to.meta.name + ' - 伊之密工业互联网平台';
  }

  next();
  // console.log(store.state.is_base_data_ready)
  // // next()
  // while (1) {

  // }
});
router_c.afterEach((to, from) => {
  NProgress.done();

  if (to.meta.name) {
    //第一次进来的时候power还没取到，所以判断有meta的时候才加tab
    store.commit('TO_ROUTER_TABS', [to, from]);
  }
  if (!Vue.prototype.store.state.is_monitor_full) {
    Vue.prototype.utils.event_hub.$emit('TOGGLE_TABBAR', false);
  }

  let tooltip = document.getElementsByClassName('gantt_tooltip');
  tooltip[0] && tooltip[0].remove();

  //优先取url上面携带的埋点id
  const uuid = to.query.logId ? to.query.logId : new Date().valueOf();
  sessionStorage.setItem('bury-uuid', uuid);
});

sync(store, router_c);
export default router_c;
